<template>
  <div
    class="uploading-files"
    :class="{ open: isUploaderOpen, floating: floating }"
    :style="styleObject"
  >
    <b-link
      class="toggler d-flex align-items-center justify-content-center"
      @click="isUploaderOpen = !isUploaderOpen"
    >
      <GjIcon
        name="LoaderAlt"
        size="24"
        class="spinner"
      />
    </b-link>
    <div v-if="showFiles">
      <template v-for="(item, index) in requestFiles">
        <upload-progress
          v-if="
            item.data.isUploading &&
              (item.data.bucketName !== bucketName ||
                (item.data.uploadPath === null ||
                  item.data.uploadPath !== currentUploadPath))
          "
          :key="`upload${item.data.isUploading}${index}`"
          :index="index"
          :files="item.uploadData.files.length"
          :bucket-name="item.data.bucketName"
          :upload-path="item.data.uploadPath"
          :project-id="item.data.projectId"
          :project-name="item.data.projectName"
          show-path
          @hide="isUploaderOpen = false"
          @cancel="cancel(index)"
        />
      </template>
    </div>
  </div>
</template>
<script>
import { cancelAllTokens } from '@/services/upload'
import UploadProgress from './UploadProgress.vue'

export default {
  name: 'UploadFilesProgress',
  components: {
    UploadProgress,
  },
  data() {
    return {
      isUploaderOpen: false,
      floating: false,
      showFiles: true,
      styleObject: {
        transition: 'right 0.4s cubic-bezier(0.05, 0.74, 0.2, 0.99)',
      },
    }
  },
  computed: {
    requestFiles() {
      return this.$store.state.uploading.requestFiles
    },
    previousRouteName() {
      return this.$store.state.app.previousRouteName
    },
    currentUploadPath() {
      return this.$store.state.uploading.currentUploadPath
    },
    bucketName() {
      return this.$store.state.uploading.bucketName
    },
  },
  created() {
    if (
      this.previousRouteName === 'object-files'
      || this.$route.name === 'object-files'
    ) {
      this.styleObject = {
        transition: 'right 1s ease-out, top 1s ease-out',
      }
      this.floating = true
      this.showFiles = false
      setTimeout(() => {
        this.floating = false
      }, 20)
      setTimeout(() => {
        this.styleObject = {
          transition: 'right 0.4s cubic-bezier(0.05, 0.74, 0.2, 0.99)',
        }
        this.showFiles = true
      }, 1200)
    }
  },
  methods: {
    cancel(index) {
      this.confirmDelete(
        'Cancel Uploading Files',
        'Are you sure you want to cancel uploading files?',
        'Continue',
      ).then(ok => {
        if (ok) {
          cancelAllTokens(index)
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.uploading-files {
  width: calc(100% - 40px);
  max-width: 400px;
  right: -400px;
  z-index: 1040;
  position: fixed;
  top: 0;
  &.open {
    right: 0;
    .toggler {
      box-shadow: -3px 0px 8px rgba(#000, 0.1);
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      left: -34px;
      background: var(--primary);
      color: var(--white);
    }
  }
  .toggler {
    position: absolute;
    border-radius: 6px;
    left: -125px;
    transition: left 0.4s cubic-bezier(0.05, 0.74, 0.2, 0.99),
      padding 0.65s linear;
    top: 15px;
    background: var(--white);
    padding: 5px;
    box-shadow: 0px 2px 8px rgb(5 45 97 / 8%);
  }
  .uploading-file-progress {
    background-color: #f1f6fe;
  }
  .cancel-button {
    padding: 4px;
    color: #000 !important;
  }
  .progress-text-wrapper {
    margin-bottom: 8px;
  }
  &.floating {
    right: 10vw;
    top: 20vh;
    .toggler {
      padding: 20px 120px;
    }
  }
}
</style>
